export function CTASection() {
    return (
        <section className="py-16 bg-gradient-to-r from-purple-600 to-pink-600">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-3xl font-bold text-white mb-4">
                    Ready to Humanize Your AI Content?
                </h2>
                <p className="text-xl text-purple-100 mb-8">
                    Join thousands of users who trust AI Humanit for authentic content.
                </p>
            </div>
        </section>
    );
}